//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.Stock.js";
let d=[[[0,"Application",0,"Routing.OverstockApplication",0]],[[["number_of_segments"],"GetOverstockSegments",{R_:{segments:"Curve[]"}},0,0],[[],"GetOverstockType",{R_:{type:''}},0,0],[[],"GetOverstockCreationMethod",{R_:{creation_method:''}},0,0],[[],"GetNumberOfWraps",{R_:{number_of_wraps:"Scalar"}},0,0],[[],"GetPercentageOverlap",{R_:{percentage_overlap:"Scalar"}},0,0],[[],"GetGapDistance",{R_:{gap_distance:"Scalar"}},0,0],[[],"GetWidth",{R_:{width:"Scalar"}},0,0],[[],"GetThickness",{R_:{thickness:"Scalar"}},0,0],[["number_of_covered_overstocks"],"GetCoveredStocks",{R_:{covered_stocks:"Routing.Stock[]"}},0,0]],[]];
SPLM.Routing.Overstock = class extends SPLM.Routing.Stock{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Overstock";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.Type = Object.freeze({
    "Unknown" : "Unknown", "FixedCrossSection" : "FixedCrossSection", "Wrapped" : "Wrapped", "Sleeved" : "Sleeved", "Flagged" : "Flagged"});

SPLM.Routing.CreationMethod = Object.freeze({
    "Unknown" : "Unknown", "EntireSegments" : "EntireSegments", "Interval" : "Interval", "PointToPoint" : "PointToPoint", "PointAndLength" : "PointAndLength"});

export default SPLM;